<script>
// import axios from "axios";

import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { mapActions, mapGetters } from "vuex";
import moment from "moment";

/**
 * Advanced table component
 */
export default {
  page: {
    title: "Budget",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      title: "Previous Debts",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "Fees",
          active: true,
        },
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortBy: "age",
      sortDesc: false,
      fields: [
        {
          key: "index",
          label: "No",
          sortable: true,
        },
        {
          key: "name",
          label: "Student Name",
          sortable: true,
        },
        {
          key: "stream",
          label: "Stream",
          sortable: true,
        },
        {
          sortable: false,
          key: "actions",
          label: "Previous Balance",
        },
      ],
      data: {
        class: "",
        stream: "",
        term: "",
        year: moment(new Date()).format("YYYY"),
      },
      years: [
        { name: new Date().getFullYear() },
        { name: new Date().getFullYear() - 1 },
        { name: new Date().getFullYear() - 2 },
        { name: new Date().getFullYear() - 3 },
      ],
      classStr: [],
      classError: "",
      termError: "",
      data1: {
        amount: "",
        id: "",
      },
      assigned: [],
    };
  },
  computed: {
    ...mapGetters("settings", ["CurrentSettings"]),
    ...mapGetters("fees", ["PreviousDebts"]),
    ...mapGetters("classes", ["CourseLevels", "AllCourses"]),
    /**
     * Total no. of records
     */
    rows() {
      return this.assigned ? this.assigned.length : 1;
    },
  },
  watch: {
    PreviousDebts(newValue) {
      if (newValue) {
        this.assign();
      }
    },
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.assigned ? this.assigned.length : 1;
  },
  methods: {
    ...mapActions({
      FetchSettings: "settings/fetchCurrentSettings",
      FetchDebts: "fees/fetchPreviousDebts",
      AddPreviousDebt: "fees/savePDebts",
      FetchCourses: "classes/fetchCourses",
      FetchCourseLevels: "classes/fetchCourseLevels",
    }),

    /**
     * Search the table data with search input
     */
    onFiltered() {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = this.assigned ? this.assigned.length : 1;
      this.currentPage = 1;
    },
    fetch_balances() {
      if (this.data.class == "") {
        this.classError = "Please Select a Class";
        return;
      }
      if (this.data.term == "") {
        this.termError = "Please Select a Level/Grade";
        return;
      }
      if (this.data.year == "") {
        this.data.year = moment(new Date()).format("YYYY");
      }
      this.FetchDebts(this.data);
    },
    addPreviousDebt(value, id) {
      if (value != "") {
        this.data1.amount = value;
        this.data1.id = id;
        this.AddPreviousDebt(this.data1);
      }
    },
    assign() {
      this.assigned = this.PreviousDebts;
    },
    resetError() {
      this.classError = "";
      this.termError = "";
    },
    filterStreams() {
      this.classStr = this.CourseLevels.filter((course) => {
        return course.level == this.data.class;
      });
    },

    closeModal(modalId) {
      this.$nextTick(() => {
        this.$bvModal.hide(modalId);
      });
    },
  },
  created() {
    this.FetchSettings();
    this.FetchCourses();
    this.FetchCourseLevels();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-md-3">
                <div class="form-group mb-1">
                  <label>Course <small class="text-danger">*</small></label>
                  <div class="input-group">
                    <select
                      required
                      class="form-control form-control-sm"
                      v-model="data.class"
                      @change="filterStreams()"
                    >
                      <option value="" selected disabled>Select Course</option>
                      <option
                        v-for="(classDetails, index) in AllCourses"
                        :key="index"
                        :value="classDetails.id"
                      >
                        {{ classDetails.name }}
                      </option>
                    </select>
                  </div>
                  <div class="text-danger" v-if="classError">
                    <em>{{ classError }}</em>
                  </div>
                </div>
              </div>
              <div class="col-md-2">
                <div class="form-group mb-1">
                  <label
                    >Level/Grade <small class="text-danger">*</small></label
                  >
                  <div class="input-group">
                    <select
                      class="form-control form-control-sm"
                      v-model="data.term"
                      @input="resetError()"
                    >
                      <option value="" selected disabled
                        >Select Level/Grade</option
                      >
                      <option
                        v-for="(classStream, index) in classStr"
                        :key="index"
                        :value="classStream.id"
                      >
                        {{ classStream.short }}
                      </option>
                    </select>
                  </div>
                  <div class="text-danger" v-if="classError">
                    <em>{{ termError }}</em>
                  </div>
                </div>
              </div>
              <div class="col-md-2">
                <div class="form-group">
                  <label>Year</label>
                  <div class="input-group">
                    <select
                      class="form-control form-control-sm"
                      v-model="data.year"
                      @input="resetError()"
                    >
                      <option
                        v-for="(y, index) in years"
                        :key="index"
                        :value="y.name"
                      >
                        {{ y.name }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="col-md-2">
                <div class="form-group" align="center">
                  <button
                    class="btn btn-success btn-sm mt-4"
                    @click="fetch_balances()"
                  >
                    <i class="fa fa-search"></i> Search
                  </button>
                </div>
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                      class="form-select form-select-sm"
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div
                  id="tickets-table_filter"
                  class="dataTables_filter text-md-end"
                >
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                      v-model="filter"
                      type="search"
                      placeholder="Search..."
                      class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                class="datatables"
                :items="assigned ? assigned : []"
                :fields="fields"
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :filter="filter"
                :filter-included-fields="filterOn"
                @filtered="onFiltered"
              >
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>
                <template #cell(actions)="data">
                  <input
                    type="text"
                    class="form-control custom"
                    v-model="data.item.amount"
                    @blur="addPreviousDebt($event.target.value, data.item.id)"
                  />
                </template>
              </b-table>
            </div>
            <div class="row">
              <div class="col">
                <div
                  class="dataTables_paginate paging_simple_numbers float-end"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
<style scoped>
.required {
  color: red !important;
}
/* .custom{
    width: 350px;
} */
</style>
